import { getText } from '@storebrand-digital/fms-translations';
import {
  ErrorMessage,
  Errors,
  ObjectSchema,
  ObjectSchemaErrors,
  StringSchema
} from '../../types';
import { joinErrors } from '../../validation/utils';
import { hasErrors } from '../../validation/validateSchema';

const getGeneralErrors = (
  errors: Errors<ObjectSchema>
): Array<ErrorMessage> => {
  if (!hasErrors(errors)) {
    return [];
  }
  return ['errors.destinationField.invalid'];
};

type GetErrorProps = {
  forceShowError: boolean | undefined;
  errors: ObjectSchemaErrors<{
    countryName: StringSchema;
    countryCode: StringSchema;
  }>;
};

export const getError = ({ forceShowError, errors }: GetErrorProps) => {
  const generalErrors = getGeneralErrors(errors);
  return forceShowError && generalErrors.length > 0
    ? joinErrors(generalErrors, getText)
    : '';
};
